export const actions = {
  set: 'SET::CONTRACTOR',
  get: 'GET::CONTRACTOR'
}

export const setContractor = contractor => ({ type: actions.set, registeredContractor: contractor })
export const getContractor = state => state.contractor.registeredContractor

export default actions
